import ApiService from "@/common/api.service"

export const RenewalStatusReportService = {
    getNewlyCpdProviders(query) {
        let queryParam = `/renewal-status-report/newly-cpd-providers${query}`;
        return ApiService.get(queryParam);
    },
    getNewlyAccreditors(query) {
        let queryParam = `/renewal-status-report/newly-accreditors${query}`;
        return ApiService.get(queryParam);
    },
    getaccreditorRenewalReport(query) {
        let queryParam = `/renewal-status-report/accreditor-renewals${query}`;
        return ApiService.get(queryParam);
    },
    getCpdProviderRenewalReport(query) {
        let queryParam = `/renewal-status-report/cpd-provider-renewals${query}`;
        return ApiService.get(queryParam);
    }
}